export { NOOP } from '@vue/shared';
//# sourceMappingURL=functions.mjs.map
